<template>
  <el-form ref="registerForm" :model="formData.obj" :rules="rules" label-position="top">
    <el-form-item :label="$t('message.home.username')" prop="username">
      <div class="ipt_box">
        <el-input v-model="formData.obj.username" :placeholder="$t('message.home.pleaseEnterUsername')"
          @keyup.enter.native="registerEvent" :maxlength="64"
          :class="itemname !== 'SM-wholesale shop' && itemname == 'FamilyShop' ? '' : 'email_ipt'" />
        <!-- <el-button type="primary" class="send_code" v-if="itemname=='SM-wholesale shop'" @click="sendCode()" @submit.native.prevent :disabled='codedis'>{{sendtext}}</el-button> -->
      </div>

    </el-form-item>
    <el-form-item :label="$t('message.home.password')" prop="password">
      <el-input v-model="formData.obj.password" :type="showPassword ? 'password' : 'text'"
        :placeholder="$t('message.home.pleaseEnterPassword')" @keyup.enter.native="registerEvent">
        <template slot="suffix">
          <img class="password-icon" :src="showPassword ? imageMap.close : imageMap.open"
            @click="showPassword = !showPassword" />
        </template>
      </el-input>
    </el-form-item>
    <el-form-item :label="$t('message.home.confirmPassword')" prop="rePassword">
      <el-input :type="showConfirm ? 'password' : 'text'" v-model="formData.obj.rePassword"
        :placeholder="$t('message.home.plaseeENterConfirmPassword')">
        <template slot="suffix">
          <img class="password-icon" :src="showConfirm ? imageMap.close : imageMap.open"
            @click="showConfirm = !showConfirm" />
        </template>
      </el-input>
    </el-form-item>
    <el-form-item :label="$t('message.home.orderEmail')" prop="email">
      <div class="ipt_box">
        <el-input v-model="formData.obj.email" :placeholder="$t('message.home.pleaseEnterEmail')"
          @keyup.enter.native="registerEvent" :maxlength="64"
          :class="itemname !== 'SM-wholesale shop' && itemname == 'FamilyShop' ? '' : 'email_ipt'" />
        <!-- <el-button type="primary" class="send_code" v-if="itemname=='SM-wholesale shop'" @click="sendCode()" @submit.native.prevent :disabled='codedis'>{{sendtext}}</el-button> -->
      </div>
    </el-form-item>


    <!-- <el-form-item :label="$t('message.home.orderEmail')" prop="username">
      <div class="ipt_box">
        <el-input v-model="registerModel.username" :placeholder="$t('message.home.pleaseEnterEmail')"
          @keyup.enter.native="registerEvent" :maxlength="64"
          :class="itemname !== 'SM-wholesale shop' && itemname == 'FamilyShop' ? '' : 'email_ipt'" />
      </div>

    </el-form-item> -->

    <!-- <el-form-item :label="$t('message.home.验证码')" prop="verifcode" v-if="itemname=='SM-wholesale shop'">
      <el-input  v-model.trim="registerModel.verifcode"
          :placeholder="$t('message.home.请输入验证码')"
          oninput="value=value.replace(/[^\d]/g,'')"
          maxlength="6">

      </el-input>
    </el-form-item> -->
    <el-form-item :label="$t('message.home.mobilePhone')" prop="mobile"
      >
      <!-- <div class="form_phone form-phone"> -->
        <el-input v-model.trim="formData.obj.mobile" :placeholder="$t('message.home.pleaseEnterPhoneNumer')"
          maxlength="30" @keyup.enter.native="registerEvent"></el-input>
        <!-- <VueCountryIntl v-model="registerModel.areaCode" schema="popover"
          :searchInputPlaceholder="$t('message.home.searchCountry')" :noDataText="$t('message.home.noDataFound')">
          <div class="area-code flex-between" slot="reference">
            <span>+{{ registerModel.areaCode }}</span>
            <i class="el-icon-caret-bottom"></i>
          </div>
        </VueCountryIntl> -->
      <!-- </div> -->
    </el-form-item>

    <el-form-item>
      <p class="tips">
        {{ $t("message.home.loginTips") }}
        <span @click="goLogin">{{ $t("message.home.loginIn") }}</span>
      </p>
      <el-button class="sing-in-btn" type="primary" :loading="loading" @click="submitForm">
        {{ $t("message.home.signUp") }}
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import common from "@/util/common";
import { mapActions, mapMutations } from "vuex";
import VueCountryIntl from "vue-country-intl";
import { BASE_AREA_CODE } from "@/common";

import {
		check_username,
		check_email,
		check_mobile,
		index,
		submit,
	} from '@/api/upms/register.js'

export default {
  name: "EsAccountForm",
  data() {
    return {
      loading: false,
      codedis: false,
      sendtext: this.$t("message.home.发送"),
      itemname: process.env.VUE_APP_ITEM_NAME,
      agentCode: '',
      registerModel: {
        username: "",
        password: "",
        confirmPassword: "",
        areaCode: BASE_AREA_CODE,
        phone: "",
        // verifcode:""
      },
      showPassword: true,
      showConfirm: true,
      imageMap: {
        open: require("@/assets/image/eye-open.png"),
        close: require("@/assets/image/eye-close.png"),
      },
      rules: {
        username: [
          common.ruleUtils.getRule(
            "required",
            '用户名不能为空'
          ),
          // common.ruleUtils.getRule("email"),
        ],
        password: [
          common.ruleUtils.getRule(
            "required",
            this.$t("message.home.pleaseEnterPassword")
          ),
          common.ruleUtils.getRule("password"),
        ],
        // usercode: [common.ruleUtils.getRule('sixNumber')],
        confirmPassword: [
          common.ruleUtils.getRule(
            "required",
            this.$t("message.home.plaseeENterConfirmPassword")
          ),
          common.ruleUtils.getRule("validator", "", {
            validator: (rule, value, callback) => {
              if (value !== this.registerModel.password) {
                callback(new Error(this.$t("message.home.twoPawword")));
                return;
              }
              callback();
            },
          }),
        ],
        email: [
          common.ruleUtils.getRule(
            this.$t("message.home.inpuEmailErro")
          ),
          common.ruleUtils.getRule("email"),
        ],
      },

/////////////////////////////////////////////////////////////////////////////////////


        merchantItemList: [],
				imgsrc: '',
				idxs: [],
				// multiArray: [
				// 	[app.globalData.messages['Region_demo0']],
				// 	[app.globalData.messages['Region_demo1']],
				// 	[app.globalData.messages['Region_demo2']]
				// ],
				formData: {
					obj: {
            username:'',
            password:'',
            rePassword:'',
            email:'',
            mobile:'',
          },
					items: {},
				},
				// rules: {
				// },
				is_check: false,


////////////////////////////////////////////////////////////////////////////////////






    };
  },
  activated() {
    // if (this.registerModel.username) {
    //   this.registerModel.username = '';
    //   this.registerModel.password = '';
    //   this.registerModel.confirmPassword = '';
    // }
    // this.$refs.reigsterForm.validateOnRuleChange = false;
    // if (this.itemname == 'SM-wholesale shop' || this.itemname == 'FamilyShop') {
    //   let rule = {
    //     phone: [
    //       common.ruleUtils.getRule(
    //         "required",
    //         this.$t("message.home.pleaseEnterPhoneNumer")
    //       ),
    //       common.ruleUtils.getRule("phone"),
    //     ],
    //     // verifcode: [
    //     //     common.ruleUtils.getRule(
    //     //       "required",
    //     //       this.$t("message.home.请输入验证码")
    //     //     ),
    //     //   ],
    //   }
    //   this.rules = { ...this.rules, ...rule }
    // }

  },
  // components: { VueCountryIntl },
  methods: {
    ...mapActions(["getUserInfo"]),
    ...mapMutations({ setToken: "SETTOKEN" }),
    async sendCode() {
      const rule = /^([A-Za-z0-9_\-\.\w{3,}])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
      if (rule.test(this.registerModel.username)) {
        await getVeriCodeApi({ target: this.registerModel.username })
        this.$message({
          message: this.$t("message.home.已发送，请注意查收"),
          type: "success",
        });
        let num = 61
        let timer = setInterval(() => {
          num--;
          this.sendtext = num + 's';
          if (num == 0) {
            clearInterval(timer);
            this.sendtext = this.$t("message.home.发送");
            this.codedis = false;
          }
        }, 1000)
        this.codedis = true;
      } else {

        this.$message({
          message: this.$t("message.home.inpuEmailErro"),
          type: "error",
        })
      }
    },

    registerEvent() {

      this.$refs.reigsterForm.validate(async (valid) => {
        if (valid) {
          try {
            if (localStorage.getItem('agentCode')) {
              this.agentCode = localStorage.getItem('agentCode');
            }
            this.loading = true;
            const registerModel = {
              username: this.registerModel.username,
              password: this.registerModel.password,
              confirmPassword: this.registerModel.confirmPassword,
              type: 2,
              re_password: this.registerModel.password,
              agentCode: this.agentCode,
            };

            if (this.itemname == 'SM-wholesale shop' || this.itemname == 'FamilyShop') {
              registerModel.phone = this.registerModel.areaCode +
                " " +
                this.registerModel.phone
              const registerResult = await JustRegisterApi(registerModel)
              this.setToken(registerResult.data.token);
              await this.getUserInfo(registerResult.data);
              this.$refs.reigsterForm.resetFields();
              this.$message({
                message: this.$t("message.home.registerSuccess"),
                type: "success",
              });
              this.$router.replace("/");

            } else {
              const registerResult = await resgisterApi(registerModel);
              this.setToken(registerResult.data.token);
              await this.getUserInfo(registerResult.data);
              this.$refs.reigsterForm.resetFields();
              this.$message({
                message: this.$t("message.home.registerSuccess"),
                type: "success",
              });
              this.$router.replace("/");
            }

          } finally {
            this.loading = false;
          }
        }
      });
    },
    goLogin() {
      sessionStorage.setItem("path", "/register");
      this.$router.push("/login");
    },


    ///////////////////////////////////////////////////////////////////////////////////////


    			/** 提交按钮 */
			submitForm(e) {
        this.$refs.registerForm.validate(valid => {
          if (valid) {
              if (this.formData.obj.rePassword != this.formData.obj.password) {
                this.$message({
                    message: '密码和确认密码不相同！',
                    type: "success",
                });
                return;
              }
              this.member_register_submit();
          }					
				})
			},
			member_register_submit() {
        let spreadUserId=localStorage.getItem("spreadUserId");
				if(spreadUserId){
					this.formData.obj.spreadUserId=spreadUserId;
				}
				submit(this.formData.obj).then(response => {
          this.$message({
                message: '提交成功！',
                type: "success",
            });
          this.$message({
            message: this.$t("message.home.registerSuccess"),
            type: "success",
          });
          this.$router.replace("/");
				}).catch(error => {
          this.$message({
            message: error.message || '注册失败',
            type: "error",
          });
        })
			},

			/**
			 * 详情
			 */
			merchant_register_add: function() {
				if (this.orderId != '') {
          this.loading=true;
					index().then(response => {
						this.loading=false;
						this.merchantItemList = response.data.data.merchantItemList;
						if (this.merchantItemList && 0 < this.merchantItemList.length) {
							this.merchantItemList.forEach((item, k) => {
								this.idxs.push(0);
								if (item.options && 0 < item.options.length) {
									let options = item.options;
									for (let i = 0; i < options.length; i++) {
										if (this.formData.items) {
											for (let z = 0; z < this.formData.items.length; z++) {
												if (this.formData.items[z] === options[i]) {
													this.$set(this.idxs, k, i);
												}
											}
										}
									}
								}
							})
						}
					}).catch(error => {
						this.loading=false;
						console.error("error", error);
						// uni.showToast({
						// 	title: this.messages['common_message_unknownError'],
						// 	duration: 2000
						// });
					})
				}
			},

			// 插入图片
			chooseImage(index) {
				uni.chooseImage({
					count: 1, //默认9
					sizeType: ['original', 'compressed'], //可以指定是原图还是压缩图，默认二者都有
					sourceType: ['album', 'camera'], //从相册选择
					success: async (res) => {
						this.loading=true;
						var tempFilePaths = res.tempFilePaths;						
						for (let temp of tempFilePaths) {
							// 图片上传服务器
							await uni.uploadFile({
								url: baseURL +
									"/goods/merchant/goods/upload_goods_image?path=profile",
								filePath: temp,
								// name: this.fileKeyName,
								name: 'file',
								// header: this.header,
								header: app.globalData.headersFile,
								success: res => {
									let goodsImage = JSON.parse(res.data);
									this.imgsrc = goodsImage.data.source;
									this.formData.items[index] = goodsImage.data.source;
									this.loading=false;
								},
							});
						}
					}
				});
			},


			bindPickerChange: function(index, e) {
				this.$set(this.idxs, index, e.detail.value);
				this.$set(this.formData.items, index, this.merchantItemList[index].options[e.detail.value]);
			},

			change(index, e) {
				this.$set(this.formData.items, index, e);
			},
			
			checkboxChange: function (index,e) {
				this.$set(this.formData.items, index, e.detail.value);
			},

			checkedradio: function(value) {
				this.is_check = !value;
			}


    ////////////////////////////////////////////////////////////////////////////////////////



  },
};
</script>
<style lang="scss" scoped>
html[dir="rtl"] {
  .el-form-item v::deep .el-form-item__error {
    right: 0;
    left: auto;
  }

  .el-input {
    .el-input__suffix {
      left: 5px;
      right: auto;
      margin-left: 10px;
    }
  }

  .el-input--suffix .el-input__inner {
    padding-left: 15px;
    padding-right: 15px;
  }
}

.vue-country-item.selected .selected-text {
  display: none;
}

.ipt_box {
  display: flex;
  max-width: 500px;

  .email_ipt {
    margin-right: 5px;
  }

  .send_code {
    flex: 1;
    min-width: 112px;
  }
}
</style>